import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScanOutlinedSvg from "@ant-design/icons-svg/es/asn/ScanOutlined";
import AntdIcon from '../components/AntdIcon';
var ScanOutlined = function ScanOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ScanOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ScanOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ScanOutlined';
}
export default RefIcon;